import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

//@ts-ignore
import type MarkdownEditor from '../markdown-editor.vue'

export const llMarkdownEditorProps = buildProps({
  value: {
    type: String,
    default: () => ''
  },
  compress: {
    type: Boolean,
    default: () => true
  },
  uploadImage: {
    type: Function,
    default: (files: any) => files
  },
  imageQuality: {
    type: Object,
    default: () => ({})
  },
  mode:{
    type: String,
    values: ['tab', 'split', 'auto'],
    default: 'auto'
  }
} as const)

export const llMarkdownEditorEmits = {
  change: (value: string) => !!value,
  'update:value': (value: string) => !!value
}

// props
//@ts-ignore
export type MarkdownEditorProps = ExtractPropTypes<typeof llMarkdownEditorProps>
// emits
export type MarkdownEditorEmits = typeof llMarkdownEditorEmits
// instance
export type MarkdownEditorInstance = InstanceType<typeof MarkdownEditor>
